<!-- View full Curve -->
<!-- loader -->
<ng-container *ngIf="loading">
  Loading......
  <div class="loading">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
</div>
</ng-container>
<!-- end of loader -->
<!-- curve deatils -->
<ng-container *ngIf="!loading">
  <div class="wrapper" id="wrapper">
  <mat-grid-list cols="6" rowHeight="670px">

    <mat-grid-tile id="graphtile" rowHeight="250px" colspan="4">
        <mat-card>
          <mat-card-content>
            <app-curve-plotter
            [temperatures]="temperatures"
            [timeArray]="timeArray"
            [firstDerivative]="firstDerivative"
            [thermalValues]="thermalValues"
            [keyPoints]="{TL: TL, TE_Low:TE_Low, TE_High:TE_High, T_Sol: T_Sol}">
          </app-curve-plotter>
          </mat-card-content>
        </mat-card>
    </mat-grid-tile>

    <br><br>
    <mat-grid-tile colspan="2" rowHeight="650px" id="curve_det">
      <mat-card>
        <mat-card-content>
          <div id="listdiv">
            <form [formGroup]="keyThermalValuesForm" (submit)="onSubmit()">
              <div class="row">
                <div id="left">
                  Curve ID :
                </div>
                <div id="right">
                  <input type="text" readonly value={{curveID}}><br>
                </div>
              </div>
              <div class="row">
                <div id="left">
                  Heat Number :
                </div>
                <div id="right">
                  <input type="text" readonly value={{heatId}}><br>
                </div>
              </div>
              <div class="row">
                <div id="left">
                  Pouring Temperature (PT):
                </div>
                <div id="right">
                  <input type="text" formControlName="PouringTemperature"><br>
                </div>
              </div>

              <div class="row">
                <div id="left">
                  Liquidus Temperature (LT):
                </div>
                <div id="right">
                  <input type="text" formControlName="LiquidusTemperature"><br>
                </div>
              </div>
              <div class="row">
                <div id="left">
                  Start of Eutectic Temperature (SET):
                </div>
                <div id="right">
                  <input type="text" formControlName="TES">
                </div>
              </div>
              <div class="row">
                <div id="left">
                  Lower Eutectic Temperature (LET):
                </div>
                <div id="right">
                  <input type="text" formControlName="TELow">
                </div>
              </div>
              <div class="row">
                <div id="left">
                  Higher Eutectic Temperature (HET):
                </div>
                <div id="right">
                  <input type="text" formControlName="TEHigh">
                </div>
              </div>
              <div class="row">
                <div id="left">
                  Recalescence (&delta;T):
                </div>
                <div id="right">
                  <input type="text" formControlName="Recalescence">
                </div>
              </div>
              <div class="row">
                <div id="left">
                  Solidus Temperature (ST):
                </div>
                <div id="right">
                  <input type="text" formControlName="SolidusTemperature">
                </div>
              </div>
              <div class="row">
                <div id="left">
                  Primary Shrinkage (PS):
                </div>
                <div id="right">
                  <input type="text" formControlName="primaryShrinkage">
                </div>
              </div>
              <div class="row">
                <div id="left">
                  Primary Expansion (PE):
                </div>
                <div id="right">
                  <input type="text" formControlName="primaryExpansion">
                </div>
              </div>
              <div class="row">
                <div id="left">
                  Secondary Expansion (SE):
                </div>
                <div id="right">
                  <input type="text" formControlName="secondaryExpansion">
                </div>
              </div>
              <div class="row">
                <div id="left">
		Graphite Factor (Gr.Fact):
                </div>
                <div id="right">
                  <input type="text" formControlName="GRF1">
                </div>
              </div>
              <div class="row">
                <div id="left">
                  Conductivity Factor (CF):
                </div>
                <div id="right">
                  <input type="text" formControlName="GRF2">
                </div>
              </div>
              <div class="row">
                <div id="left">
                  Actual Carbon Equivalent (ACE):
                </div>
                <div id="right">
                  <input type="text" formControlName="ACEL">
                </div>
              </div>
              <div class="row">
                <div id="left">
                  Carbon Percentage (C%):
                </div>
                <div id="right">
                  <input type="text" formControlName="CarbonPercentage">
                </div>
              </div>
              <div class="row">
                <div id="left">
                  Grey Eutectic Temperature (GET) :
                </div>
                <div id="right">
                  <input type="text" formControlName="tegrey">
                </div>
              </div>
              <div class="row">
                <div id="left">
                  White Eutectic Temperature (WET):
                </div>
                <div id="right">
                  <input type="text" formControlName="tewhite">
                </div>
              </div>



            </form>
          </div>
        </mat-card-content>
      </mat-card>

    </mat-grid-tile>
  </mat-grid-list>
  <!-- end of curve details -->
  <!-- curve defects -->


  <mat-grid-list id="bottom" cols="6" rowHeight="150px" class="bottom-container">

    <mat-grid-tile colspan="3" >
      <mat-card id="defects">
        <h4>DEFECTS:</h4>
        <mat-card-content>
  <!-- MACRO -->
  <button *ngIf="macro >= 3" mat-raised-button color="success">
    MACRO
  </button>
  <button *ngIf="macro === 2" mat-raised-button color="accent"
    (click)="showMessage(`MACRO - MEDIUM RISK:\n• • LT slightly high – risk of shrinkage or outer sunks.\n• • May be due to low CEL or excess oxygen.`)">
    MACRO
  </button>
  <button *ngIf="macro <= 1" mat-raised-button color="warn"
    (click)="showMessage(`MACRO - HIGH RISK:\n• • LT is too high – high risk of shrinkage and sunken areas.\n• • Primary shrinkage is also high – too much primary austenite.\n• • Could be due to low ACEL or too much oxygen.`)">
    MACRO
  </button>

  <!-- MICRO -->
  <button *ngIf="micro >= 4" mat-raised-button color="success">
    MICRO
  </button>
  <button *ngIf="micro === 3" mat-raised-button color="accent"
    (click)="showMessage(`MICRO - MEDIUM RISK:\n• • ST is too low – porosity risk during final solidification.\n• • Nucleation is weak – possibly due to high temperature or melt changes.`)">
    MICRO
  </button>
  <button *ngIf="micro <= 2" mat-raised-button color="warn"
    (click)="showMessage(`MICRO - HIGH RISK:\n• • CF is too high – not enough eutectic graphite.\n• • dT/dt at ST is too high – solidification too fast.\n• • ST is too low – risk of porosity at the end.\n• • Nucleation is poor – may be due to high holding temperature or low inoculation.`)">
    MICRO
  </button>

  <!-- CHILL -->
  <button *ngIf="chill >= 2" mat-raised-button color="success">
    CHILL
  </button>
  <button *ngIf="chill === 1" mat-raised-button color="warn"
    (click)="showMessage(`CHILL - MEDIUM RISK:\n• • LET is above or lower the chill point – medium chill risk, reduce superheating, or high holding time
`)">
    CHILL
  </button>
  <button *ngIf="chill == 0" mat-raised-button color="warn"
    (click)="showMessage(`CHILL - HIGH RISK:\n• • LET is well above chill point – low chill risk.\n• • ST is above TeW – 25°C – low inverse chill risk.`)">
    CHILL
  </button>

  <!-- OTHERS -->
  <button *ngIf="segregation >= 3" mat-raised-button color="success">
    OTHERS
  </button>
  <button *ngIf="segregation == 2" mat-raised-button color="accent"
    (click)="showMessage(`OTHERS - MEDIUM RISK:\n• • Gr.F is too low – graphite formation is weak at the end.\n• • Could be due to a sample cup not fully filled.`)">
    OTHERS
  </button>
  <button *ngIf="segregation <= 1" mat-raised-button color="warn"
    (click)="showMessage(`OTHERS - HIGH RISK:\n• • CF and dT/dt at ST are high – poor graphite and heat transfer.`)">
    OTHERS
  </button>
</mat-card-content>

<ng-template #messageDialog>
  <div class="glass-dialog-content">
    <h2 mat-dialog-title class="glass-dialog-title" style="color:#bf00ff;font-weight:bolder;font-style:italic;font-size:30px; ">Possible Reasons</h2>

    <mat-dialog-content class="glass-dialog-body">
      <div [ngClass]="messageHeaderClass" class="glass-message-header">
        {{ messageTitle }}
      </div>

      <ul class="glass-message-list">
        <li *ngFor="let point of messagePoints" class="glass-message-item animate-in">
          {{ point }}
        </li>
      </ul>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-raised-button mat-dialog-close color="accent">Close</button>
    </mat-dialog-actions>
  </div>
</ng-template>

      </mat-card>
      </mat-grid-tile>

      <div class="sprt-btn">
        <!-- <button><a class="right" href="#" (click)="downloadPage()" id="btn"> DOWNLOAD PAGE</a></button> -->
        <button class="btn btn-primary"  (click)="open(mymodal, graph)">Support</button>
        <!-- <button class="btn btn-primary"  (click)="downloadPage()">Download Page</button> -->
        <div class="dropup">
          <button class="dropbtn btn btn-primary">Export
            <i class="fa fa-caret-down"></i>
          </button>
          <div class="dropup-content">
            <a class="fileFormat" (click)="export('CSV', graph)">CSV</a>
            <a class="fileFormat" (click)="export('XLS', graph)">XLS</a>
          </div>
        </div>
      </div>

    <ng-template #mymodal let-modal>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">"Please enter your Query to raise a ticket"</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <form (submit)="saveTicket()" [formGroup]="ticketForm">
        <div class="modal-body" style="margin: 0 auto;">
          <textarea rows="6" style="width:100%;" formControlName="ticket"></textarea>
          <br><br>
          <div class="columns">
            <div class="column is-one-third">
              <div class="field">
                <div class="file has-name is-primary is-fullwidth">
                 <!-- <label class="file-label">
                    <input
                      class="file-input"
                      type="file"
                      name="file"
                      #fileInput
                      (change)="onChange(fileInput.files[0])"
                    />
                  </label>-->
                </div>
              </div>

            </div>
            <div class="column">
              <figure *ngIf="imageUrl!=''">
                <img height="300" width="300" [src]="imageUrl" />
              </figure>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-outline-dark" (click)="modal.close('Save click')">raise ticket</button>
        </div>

      </form>
    </ng-template>

    <!-- <mat-grid-tile colspan="2">
      <mat-card id="defects">
        <mat-card-content>
          <button (click)="saveImage()">SAVE IMAGE</button>
          <button (click)="saveValue()">SUPPORT</button>
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile colspan="1">
      <mat-card id="defects">
        <mat-card-content>
          <button (click)="getHelp()">GET HELP</button>
        </mat-card-content>
      </mat-card>
    </mat-grid-tile> -->
  </mat-grid-list>
</div>
</ng-container>


<!-- end of curve viewer-->
